var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useReducer } from 'react';
import moment from 'moment/moment';
import { appendItem } from '../utils/arrayUtil';
export var isPendingMessage = function (body) { return !!body.id && !!body.isPending; };
var initialState = {
    messageReplyQueue: [],
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export var MessageReplyQueueContext = createContext({
    state: initialState,
});
/**
 * Will ensure the message is inserted last. If the same PendingMessage is already in the queue
 * (checked using {PendingMessage.id}), then it is re-inserted last.
 * */
var insertTemporaryMessage = function (messageReplyQueue, message) {
    // Remove any previous occurrences of this message
    // (This helps us ensure that a retried message is correctly re-placed last)
    var updatedQueue = messageReplyQueue.filter(function (it) { return it.id !== message.id; });
    return appendItem(updatedQueue, __assign(__assign({}, message), { 
        // Updated timestamp to reflect the actual time of "attempted delivery"
        createdOn: moment().toISOString() }));
};
var removeTemporaryMessageFromQueue = function (messageReplyQueue, messageToRemove) { return messageReplyQueue.filter(function (message) { return message.id !== messageToRemove.id; }); };
/**
 * Ensures the failing message is updated in the correct place
 * */
var updateMessageErrorInPlace = function (messageReplyQueue, failingMessage) { return messageReplyQueue
    .map(function (message) {
    if (message.id !== failingMessage.id) {
        return message;
    }
    return failingMessage;
}); };
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case 'INSERT_PENDING_MESSAGE':
            return __assign(__assign({}, state), { messageReplyQueue: insertTemporaryMessage(state.messageReplyQueue, action.message) });
        case 'REMOVE_PENDING_MESSAGE':
            return __assign(__assign({}, state), { messageReplyQueue: removeTemporaryMessageFromQueue(state.messageReplyQueue, action.message) });
        case 'INSERT_FAILING_PENDING_MESSAGE':
            return __assign(__assign({}, state), { messageReplyQueue: updateMessageErrorInPlace(state.messageReplyQueue, action.message) });
        default:
            return state;
    }
};
export var MessageReplyQueueProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    return React.createElement(MessageReplyQueueContext.Provider, { value: { state: state, dispatch: dispatch } }, children);
};
